/**
    商品列表
**/
<template>
        <div class="rightaside_content">
          <h3 class="headerTitle">我的退款</h3>
          <div class="headerButton">
              <span style="line-height: 28px;">订单号：<i>{{myRefundInfo.orderNumber}}</i></span>
              <!-- <div>
                    <el-button size="mini" @click="$router.push('/orderNow')">去支付</el-button>
                    <el-button size="mini" @click="cancleOrder">取消订单</el-button>
              </div> -->
          </div>
          <el-divider></el-divider>
          <div>
              <el-row class="order_goods" >
                    <el-col :span="2"> <el-image :src="`${myRefundInfo.goodsItem.photos}`"></el-image></el-col> 
                    <el-col :span="15" class="order_Info_item">
                        <p>{{myRefundInfo.goodsItem.name}}  {{myRefundInfo.goodsItem.specificationlist.length!=0?myRefundInfo.goodsItem.specificationlist[0].name:''}}</p>
                        <!-- marketprice 需要乘以折扣 -->
                        <p>{{myRefundInfo.goodsItem.realprice}} 元 * {{myRefundInfo.goodsItem.number}}</p>
                    </el-col>
                </el-row>

                <el-row class="myRefund">
                    <el-col :span="24"> <h3 class="headerTitle">退款申请</h3></el-col> 
                    <el-col>
                        <el-form  :rules="rules" ref="sizeForm" :model="sizeForm" label-width="80px" size="mini" >
                            <el-form-item label="退款原因"  prop="reasaon">
                                <!-- <el-select v-model="sizeForm.reasaon" placeholder="请选择">
                                <el-option label="商品变质" value="1"></el-option>
                                <el-option label="选错商品" value="2"></el-option>
                                </el-select> -->
                                <el-input disabled v-model="sizeForm.reasaon" placeholder="七天无理由退款"></el-input>
                            </el-form-item>
                            <el-form-item label="退款金额"  prop="amount">
                                <el-input disabled v-model="sizeForm.amount"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="退款说明"  prop="description">
                                <el-input v-model="sizeForm.description"></el-input>
                            </el-form-item> -->
                            <!-- <el-form-item label="退款凭证" prop="" class="myproof">
                                <el-upload
                                        name="files"
                                        class="avatar-uploader"
                                        :action="`custom/xunyou/api/common/upload`"
                                        :show-file-list="false"
                                        :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <img v-if="sizeForm.proof" :src="urlImg" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                </el-form-item> -->
                            <el-form-item size="large">
                                <el-button type="primary" @click="submitApply"  class="buttonBgd">申请退款</el-button>
                            </el-form-item>
                            </el-form>
                    </el-col>
                </el-row>               

          </div>

          <!-- 退款失败 -->
           <el-dialog
            :visible.sync="backdialogVisible"
            width="30%"
            center
            class="dialogBox">
            <div class="textCenter">{{msg}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="backdialogVisible=false" class="buttonBgd">确 定</el-button>
            </span>
        </el-dialog>

        </div>
</template>
<script>
import {backMoney} from '@/api/xunyou'
export default {
  data() {
    return {  
        msg:'',
        backdialogVisible:false,
         myRefundInfo:JSON.parse(sessionStorage.getItem("myRefundInfo")) || {},    
        //  orderInfoList:{
        //         id:0,
        //         status:1, // 1等待买家付款 2等待卖家发货 3等待买家确认收获 4交易成功 5交易关闭
        //         time:'2020-12-1 22:22:22',
        //         shopName:'POLA宝丽官方旗舰店',
        //         orderNum:'DD-20201204-0009',
        //         orderTotal:725,
        //         goodsList:[
        //                 {
        //                    id:0,
        //                    photos:'',
        //                    proTitle: 'SK-II大红瓶面部护肤精华面霜提亮修护补水饱满弹润官方sk2skll',
        //                    price:123,
        //                    number:1,
        //                 },
        //                 {
        //                    id:1,
        //                    photos:'',
        //                    proTitle: 'Dior迪奥 迪奥小姐香水 经典女士香水 迷人馥郁花香',
        //                    price:123,
        //                    number:1,
        //                 },
        //                  {
        //                    id:2,
        //                    photos:'',
        //                    proTitle: 'SK-II大红瓶面部护肤精华面霜提亮修护补水饱满弹润官方sk2skll',
        //                    price:123,
        //                    number:1,
        //                 },
        //                 {
        //                    id:3,
        //                    photos:'',
        //                    proTitle: 'Dior迪奥 迪奥小姐香水 经典女士香水 迷人馥郁花香',
        //                    price:123,
        //                    number:1,
        //                 }
        //             ]
        //     },
         urlImg:'', // 用来图片预览的
        sizeForm: {
            reasaon:'七天无理由退款',
            // amount: JSON.parse(sessionStorage.getItem("myRefundInfo")).goodsItem.marketprice,
            amount:JSON.parse(sessionStorage.getItem("myRefundInfo")).goodsItem.realprice*JSON.parse(sessionStorage.getItem("myRefundInfo")).goodsItem.number,
            // description:'',
            proof:'',
        },
         rules: {
            reasaon: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            amount:[ { required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            description:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            proof:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],          
        },
    }
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
      console.log(this.myRefundInfo,'退回来的')
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

      
  submitApply() {
      this.$refs.sizeForm.validate((valid) => {
        if (valid) {//  this.$router.push('/myOrder')
        const req = {
            out_trade_no:this.myRefundInfo.orderNumber,
            refund_amount:this.sizeForm.amount,
            out_request_no:this.myRefundInfo.orderNumber,
            refund_reason:this.sizeForm.reasaon,
            goodsId:this.myRefundInfo.goodsItem.id

        }
         backMoney(req)
            .then(res => {
                console.log(res,'diani1tuikuan1')
                if(res.data.alipay_trade_refund_response.code == 10000){                   
                     this.$message({
                        type: 'success',
                        message: res.data.alipay_trade_refund_response.msg
                    });
                     sessionStorage.removeItem("myRefundInfo")
                     this.$router.push('/myOrder')
                }else{
                    this.msg = res.data.alipay_trade_refund_response.msg
                    this.backdialogVisible = true
                }
            })
            .catch(err => {
              this.$message.error('退款失败，请稍后再试！')
            })
          } 
      });
    },

    //   退款凭证上传
    handleAvatarSuccess(res, file) {
        console.log(file.raw,URL.createObjectURL(file.raw))
            this.urlImg = URL.createObjectURL(file.raw) // 用来图片预览的
            this.sizeForm.proof =URL.createObjectURL(file.raw);
            // this.sizeForm.businessLicense =URL.createObjectURL(file.raw). substring(URL.createObjectURL(file.raw).lastIndexOf("/"));
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            // if (!isJPG) {
            // this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isLt2M;
        }
  },

};
</script>

<style scoped lang="less">
    .rightaside_content{
        .el-divider--horizontal {
            display: block;
            height: 1px;
            width: 100%;
            margin: 5px 0;
        }
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
            margin-bottom: 20px;
        }
        .headerButton {
            display: flex;
            justify-content: space-between;
            button.el-button.el-button--default.el-button--mini {
                // background: #ff6700;
                // color: white;
                background: #f896521a;
                color: #ff6700;
                border: 1px solid #ff6700;
            }
            .el-button.el-button--mini:focus, .el-button.el-button--mini:hover {
                background: #ff6700 !important;
                color: white !important;
            }
        }
        .order_goods.el-row {
            border-bottom: 1px solid#DCDFE6;
            padding: 20px;
            box-sizing: border-box;
        }
        .myRefund{
            padding: 40px 20px;
            box-sizing: border-box;
             /deep/input[disabled], input[disabled="disabled"], /deep/input[readonly], /deep/input[readonly="readonly"]{
                    background: white !important;
                }
                /deep/.el-select.el-select--mini {
                    width: 100%;
                }
              /deep/.avatar-uploader {
                        padding: 20px 0;
                        box-sizing: border-box;
                    }
                /deep/.el-upload.el-upload--text {
                        border: 1px solid #ccc;
                    }

                .avatar-uploader .el-upload {
                    border: 1px dashed #d9d9d9;
                    border-radius: 6px;
                    cursor: pointer;
                    position: relative;
                    overflow: hidden;
                }
                .avatar-uploader .el-upload:hover {
                    border-color: #409EFF;
                }
                .avatar-uploader-icon {
                    font-size: 28px;
                    color: #8c939d;
                    width: 178px;
                    height: 178px;
                    line-height: 178px;
                    text-align: center;
                }
                .avatar {
                    width: 160px;
                    height: 160px;
                    display: block;
                }
                .el-form-item.myproof.el-form-item--mini {
                    border-bottom: 1px solid #ccc;
                }
                 button.el-button.buttonBgd.el-button--primary {
                    background-color: #ff6700;
                    border-color: #ff6700;
                    font-size: 18px;
                    margin: 20px 0;
                }
        }
       
.textCenter {
                text-align: center;
                font-size: 25px;
            }
             button.el-button.buttonBgd.el-button--primary {
               background-color: #ff6700;
               border-color: #ff6700;
               font-size: 18px;
               margin: 20px 0;
           }
    }

</style>

 
 

 


// WEBPACK FOOTER //
// src/views_supplier/myOrder/myRefund.vue